/**
 * 任务中心递进导航：从分类列表进入业务页时带上返回上下文，关闭/返回时回到任务列表而非业务板块首页。
 */

export const TASK_RETURN_FLAG = 'task_return'

const RETURN_QUERY_KEYS = new Set([
  TASK_RETURN_FLAG,
  'task_return_name',
  'task_return_userId',
  'task_return_categoryKey',
  'task_return_scope',
  'task_return_label',
  'task_return_userName',
  'task_return_supplier_id',
  'task_return_supplier_label',
  'task_return_customer_id',
  'task_return_customer_label',
  'task_return_material_key',
  'task_return_material_label'
])

/** 从当前任务中心路由生成写入业务页 query 的返回参数 */
export function buildTaskReturnQuery(route) {
  if (!route?.name) return {}
  const q = {
    [TASK_RETURN_FLAG]: '1',
    task_return_name: String(route.name)
  }
  const uid = route.params?.userId
  const ck = route.params?.categoryKey
  if (uid != null && uid !== '') q.task_return_userId = String(uid)
  if (ck != null && ck !== '') q.task_return_categoryKey = String(ck)
  const scope = route.query?.scope
  if (scope) q.task_return_scope = String(scope)
  const label = route.query?.label
  if (label) q.task_return_label = String(label)
  const userName = route.query?.userName
  if (userName) q.task_return_userName = String(userName)
  const supplierId = route.query?.supplier_id
  if (supplierId) q.task_return_supplier_id = String(supplierId)
  const supplierLabel = route.query?.supplier_label
  if (supplierLabel) q.task_return_supplier_label = String(supplierLabel)
  const customerId = route.query?.customer_id
  if (customerId) q.task_return_customer_id = String(customerId)
  const customerLabel = route.query?.customer_label
  if (customerLabel) q.task_return_customer_label = String(customerLabel)
  const materialKey = route.query?.material_key
  if (materialKey) q.task_return_material_key = String(materialKey)
  const materialLabel = route.query?.material_label
  if (materialLabel) q.task_return_material_label = String(materialLabel)
  return q
}

/** 解析业务页 query 中的返回目标（vue-router location） */
export function parseTaskReturnRoute(query) {
  if (!query || String(query[TASK_RETURN_FLAG] || '') !== '1') return null
  const name = String(query.task_return_name || '').trim()
  if (!name) return null
  const params = {}
  if (query.task_return_userId) params.userId = String(query.task_return_userId)
  if (query.task_return_categoryKey) params.categoryKey = String(query.task_return_categoryKey)
  const rq = {}
  if (query.task_return_scope) rq.scope = String(query.task_return_scope)
  if (query.task_return_label) rq.label = String(query.task_return_label)
  if (query.task_return_userName) rq.userName = String(query.task_return_userName)
  if (query.task_return_supplier_id) rq.supplier_id = String(query.task_return_supplier_id)
  if (query.task_return_supplier_label) rq.supplier_label = String(query.task_return_supplier_label)
  if (query.task_return_customer_id) rq.customer_id = String(query.task_return_customer_id)
  if (query.task_return_customer_label) rq.customer_label = String(query.task_return_customer_label)
  if (query.task_return_material_key) rq.material_key = String(query.task_return_material_key)
  if (query.task_return_material_label) rq.material_label = String(query.task_return_material_label)
  return { name, params, query: rq }
}

export function hasTaskReturnQuery(query) {
  return !!parseTaskReturnRoute(query)
}

/** 打开业务页时合并返回参数 */
export function mergeTaskReturnIntoQuery(baseQuery, route) {
  return { ...(baseQuery || {}), ...buildTaskReturnQuery(route) }
}

/** 若存在任务返回上下文则跳转回任务中心（默认 replace，避免堆叠派工列表历史） */
export function navigateTaskReturnIfPresent(router, route, { replace = true } = {}) {
  const target = parseTaskReturnRoute(route?.query)
  if (!target) return false
  if (replace) {
    router.replace(target)
  } else {
    router.push(target)
  }
  return true
}

/** 从 query 中去掉任务返回字段（用于留在业务页但去掉自动跳回） */
export function omitTaskReturnQuery(query) {
  const out = { ...(query || {}) }
  for (const k of RETURN_QUERY_KEYS) {
    delete out[k]
  }
  return out
}
